import queryString from 'query-string'

import agent from 'agent'

const urlEncodedHeaders = {
  'Content-Type': 'application/x-www-form-urlencoded'
}

export default {
  startTrial(params) {
    return agent
      .post('companies/trial', queryString.stringify({ ...params }), {
        headers: urlEncodedHeaders
      })
      .then(({ data }) => data)
  }
}
